import { Link } from 'react-router-dom';
import { SERVICES } from '../data/services';
import { FOOTER_PAGES, SITE } from '../data/site';
import CtaBand from './CtaBand';

function Footer() {
  return (
    <footer className="footer">
      <CtaBand />

      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="logo">
            <span className="logo-eighty">Eighty</span>
            <span className="logo-three">Three</span>
            <span className="logo-labs logo-labs-dark">Labs</span>
          </div>
          <p className="footer-tagline">{SITE.tagline}</p>

          <div className="footer-contact-rows">
            <a href={`mailto:${SITE.contact.email}`} className="footer-contact-row">
              <span className="footer-contact-chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="14"
                  height="14"
                >
                  <path d="M4 4h16v16H4z" opacity="0" />
                  <path d="M22 6l-10 7L2 6" />
                  <path d="M2 6h20v12H2z" />
                </svg>
              </span>
              {SITE.contact.email}
            </a>
            <a
              href={SITE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-row"
            >
              <span className="footer-contact-chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="14"
                  height="14"
                  aria-hidden="true"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zM7.119 20.452H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </span>
              LinkedIn
            </a>
            <span className="footer-contact-row footer-contact-row-static">
              <span className="footer-contact-chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="14"
                  height="14"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              {SITE.location.city}, {SITE.location.region}
            </span>
          </div>
        </div>

        <div className="footer-links-group">
          <h4 className="footer-heading">Pages</h4>
          <ul>
            {FOOTER_PAGES.map(link => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-links-group">
          <h4 className="footer-heading">Services</h4>
          <ul>
            {SERVICES.map(service => (
              <li key={service.slug}>
                <Link to={`/services/${service.slug}`}>{service.shortTitle}</Link>
              </li>
            ))}
            <li>
              <Link to="/microsoft-365-setup">Microsoft 365 Setup</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>&copy; {new Date().getFullYear()} EightyThreeLabs. All rights reserved.</p>
        <p>
          {SITE.location.city}, {SITE.location.region} &middot; {SITE.location.serving}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
